module.exports = __webpack_public_path__ + "static/menu-Personal Trainer-8a1c474d490b703269a23142af0af5dc.png";